(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-announcement-signup]');
    if (!link) return;
    const creative = window.innerWidth >= 760 ? link.dataset.attentiveDesktop : link.dataset.attentiveMobile;
    if (!creative || typeof window.__attentive?.trigger !== 'function') return;
    try {
      window.__attentive.trigger(null, null, null, creative);
      event.preventDefault();
    } catch (error) {
      window.location.hash = 'footer-signup';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sunice-help-hub"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('input', (event) => {
    const input = event.target;
    if (!input.matches('[data-help-search]')) return;
    const hub = input.closest('[data-help-hub]');
    if (!hub) return;
    const query = input.value.trim().toLocaleLowerCase();
    let matches = 0;
    hub.querySelectorAll('[data-help-topic]').forEach((topic) => {
      const text = `${topic.textContent} ${topic.dataset.keywords || ''}`.toLocaleLowerCase();
      const visible = query === '' || text.includes(query);
      topic.hidden = !visible;
      if (visible) matches += 1;
    });
    const empty = hub.querySelector('[data-help-empty]');
    const status = hub.querySelector('[data-help-status]');
    if (empty) empty.hidden = matches !== 0;
    if (status) status.textContent = matches === 0 ? empty.textContent.trim() : '';
  });

  } catch(e) { console.error(e); }
})();
})();
